/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */
import { faker } from '@faker-js/faker';
import type { RequestHandlerOptions } from 'msw';
import { delay, HttpResponse, http } from 'msw';

import type { GetVersion200, HealthCheck200 } from './model';

export const getHealthCheckResponseMock = (
  overrideResponse: Partial<HealthCheck200> = {},
): HealthCheck200 => ({
  status: faker.string.alpha({ length: { min: 10, max: 20 } }),
  database: faker.string.alpha({ length: { min: 10, max: 20 } }),
  redis: faker.string.alpha({ length: { min: 10, max: 20 } }),
  ...overrideResponse,
});

export const getGetVersionResponseMock = (
  overrideResponse: Partial<GetVersion200> = {},
): GetVersion200 => ({
  version: faker.string.alpha({ length: { min: 10, max: 20 } }),
  ...overrideResponse,
});

export const getHealthCheckMockHandler = (
  overrideResponse?:
    | HealthCheck200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HealthCheck200> | HealthCheck200),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/health',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHealthCheckResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetVersionMockHandler = (
  overrideResponse?:
    | GetVersion200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<GetVersion200> | GetVersion200),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/version',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetVersionResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};
export const getDnRAPIMock = () => [getHealthCheckMockHandler(), getGetVersionMockHandler()];
